import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Page404Component } from './authentication/page404/page404.component';
import { AuthGuard } from './core/guard/auth.guard';
import { AuthLayoutComponent } from './layout/app-layout/auth-layout/auth-layout.component';
import { MainLayoutComponent } from './layout/app-layout/main-layout/main-layout.component';
const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: '/authentication/signin', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
      },
      {
        path: 'persona',
        loadChildren: () =>
          import('./paginas/personas/persona.module').then(
            (m) => m.PersonaModule
          ),
          canActivate: [AuthGuard]
      },
      {
        path: 'agente',
        loadChildren: () =>
          import('./paginas/agentes/agente.module').then(
            (m) => m.AgenteModule
          ),
          canActivate: [AuthGuard]
      },
      {
        path: 'patio',
        loadChildren: () =>
          import('./paginas/patio/patio.module').then(
            (m) => m.PatioModule
          ),
          canActivate: [AuthGuard]
      },
      {
        path: 'grua',
        loadChildren: () =>
          import('./paginas/gruas/grua.module').then(
            (m) => m.GruaModule
          ),
          canActivate: [AuthGuard]
      },
      {
        path: 'rangos-comparendos',
        loadChildren: () =>
          import('./paginas/rangos-comparendos/rangos-comparendos.module').then(
            (m) => m.RangosComparendosModule
          ),
          canActivate: [AuthGuard]
      }, {
        path: 'gestion-documental',
        loadChildren: () =>
          import('./paginas/pqrs/pqrs.module').then(
            (m) => m.PqrsModule
          ),
        canActivate: [AuthGuard]
      },
      {
        path: 'comparendos',
        loadChildren: () =>
          import('./paginas/comparendos/comparendo.module').then(
            (m) => m.ComparendoModule
          ),
          canActivate: [AuthGuard]
      }, {
        path: 'descuento',
        loadChildren: () =>
          import('./paginas/descuento/descuento.module').then(
            (m) => m.DescuentoModule
          ),
          canActivate: [AuthGuard]
      }, {
        path: 'sanciones',
        loadChildren: () =>
          import('./paginas/sanciones/sanciones.module').then(
            (m) => m.SancionesModule
          ),
          canActivate: [AuthGuard]
      }, {
        path: 'audiencias',
        loadChildren: () =>
          import('./paginas/audiencias/audiencia.module').then(
            (m) => m.AudienciaModule
          ),
          canActivate: [AuthGuard]
      }, {
        path: 'liquidacion',
        loadChildren: () =>
          import('./paginas/liquidacion/liquidacion.module').then(
            (m) => m.LiquidacionModule
          ),
          canActivate: [AuthGuard]
      },
      {
        path: 'acuerdo-pago',
        loadChildren: () =>
          import('./paginas/acuerdos-pago/acuerdos-pago.module').then(
            (m) => m.AcuerdosPagoModule
          ),
          canActivate: [AuthGuard]
      },
      {
        path: 'cargues-simit',
        loadChildren: () =>
          import('./paginas/plano-simit/plano-simit.module').then(
            (m) => m.PlanoSimitModule
          ),
          canActivate: [AuthGuard]
      }, {
        path: 'migracion-comparendos',
        loadChildren: () =>
          import('./paginas/migracion-comparendos/migracion-comparendos.module').then(
            (m) => m.MigracionComparendosModule
          ),
          canActivate: [AuthGuard]
      }, {
        path: 'migracion-comparendos/resoluciones',
        loadChildren: () =>
          import('./paginas/migracion-resoluciones/migracion-resoluciones.module').then(
            (m) => m.MigracionResolucionesModule
          ),
          canActivate: [AuthGuard]
      }, {
        path: 'migracion-comparendos/recaudos',
        loadChildren: () =>
          import('./paginas/migracion-recaudos/migracion-recaudos.module').then(
            (m) => m.MigracionRecaudosModule
          ),
          canActivate: [AuthGuard]
      }, {
        path: 'usuarios',
        loadChildren: () =>
          import('./paginas/usuarios/usuarios.module').then(
            (m) => m.usuariosModule
          )
      },{
        path: 'administracion',
        loadChildren: () =>
          import('./paginas/administracion/administracion.module').then(
            (m) => m.AdministracionModule
          )
      },{
        path: 'cobro-coactivo',
        loadChildren: () =>
          import('./paginas/cobro-coactivo/cobro-coactivo.module').then(
            (m) => m.CobroCoactivoModule
          )
      },{
        path: 'foto-detecciones',
        loadChildren: () =>
          import('./paginas/foto-deteccion/foto-deteccion.module').then(
            (m) => m.FotoDeteccionModule
          ),
          canActivate: [AuthGuard]
      },{
        path: 'reimpresiones',
        loadChildren: () =>
          import('./paginas/reimpresiones/reimpresiones.module').then(
            (m) => m.ReimpresionesModule
          )
      },
      {
        path: 'actos-administrativos',
        loadChildren: () =>
          import('./paginas/actos-administrativos/actos-administrativos.module').then(
            (m) => m.ActoAdministrativoModule
          )
      },
      {
        path: 'parqueaderos',
        loadChildren: () =>
          import('./paginas/parqueaderos/parqueaderos.module').then(
            (m) => m.ParqueaderosModule
         ),
          canActivate: [AuthGuard]
      },
      {
        path: 'chat-ia',
        loadChildren: () =>
          import('./paginas/chat-ia/chat-ia.module').then(
            (m) => m.ChatIaModule
          ),
        canActivate: [AuthGuard]
      },
      {
        path: 'inspectores',
        loadChildren: () =>
          import('./paginas/inspectores/inspectores.module').then(
            (m) => m.InspectoresModule
          ),
        canActivate: [AuthGuard]
      }

    ],
  },
  {
    path: 'authentication',
    component: AuthLayoutComponent,
    loadChildren: () =>
      import('./authentication/authentication.module').then(
        (m) => m.AuthenticationModule
      ),
  },
  { path: '**', component: Page404Component },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule { }
